import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { CopiableContactField } from '@/components/research-bar/copiable-contact-field'

interface CloudyContactCardProps {
  children: ReactNode
  title: string
}

interface CloudyCopiableContactCardProps {
  icon: LucideIcon
  label: string
  title: string
  value: string
}

export function CloudyContactCard({ children, title }: CloudyContactCardProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-brand-500 p-5 sm:p-6">
      {/* Décor : `z-0` explicite et `max-w` — sans quoi le nuage, à sa taille
          native, recouvrait le titre sur une carte étroite. */}
      <img
        alt=""
        aria-hidden
        className="pointer-events-none absolute top-0 right-0 z-0 max-w-[45%] opacity-70"
        src="/icons/cloud.svg"
      />
      <div className="relative z-10 flex flex-col gap-3">
        <h3 className="text-xl font-semibold break-words text-white">{title}</h3>
        {children}
      </div>
    </div>
  )
}

export function CloudyCopiableContactCard({
  icon,
  label,
  title,
  value,
}: CloudyCopiableContactCardProps) {
  return (
    <CloudyContactCard title={title}>
      <CopiableContactField
        fieldClassName="border-none bg-white"
        icon={icon}
        iconClassName="text-gray-light-500"
        label={label}
        labelClassName="text-sm font-medium text-white"
        value={value}
      />
    </CloudyContactCard>
  )
}
